import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

/* Redux modules */
import Actions from '../../../../../../store/actions';

/* Error modules */
import { DropdownItem, DropdownText } from './ProfileItemsList';
import { LogoutIcon } from '../../../editJournal/toolset/assets/icons';
import RedirectAppURL from '../../../../../../../../common/redirectApp';
import { handleSignOut } from './authUtils/handleSignOut';

const Logout = (props) => {
  const { sideDrawerClosedHandler, appType } = props;

  return (
    <Link
      to={`${RedirectAppURL({ appType })}`}
      className="p-0"
      style={{ color: 'none', textDecoration: 'none' }}
      key={`${RedirectAppURL({ appType })}`}
      onClick={(e) => {
        e.stopPropagation();
        handleSignOut(props);
        sideDrawerClosedHandler();
      }}
      data-testid="Sign out"
    >
      <DropdownItem last>
        <LogoutIcon height="20" width="20" />
        <DropdownText>Logout</DropdownText>
      </DropdownItem>
    </Link>
  );
};

const mapStateToProps = (state) => ({
  userInfo: state.user,
  webSocket: state.websocket.webSocket,
});

const mapDispatchToProps = (dispatch) => ({
  signOut: () => {
    dispatch(Actions.storeUserProfile.signOut());
  },
  clearUserInfo: () => {
    dispatch(Actions.userInfoActions.clearUserInfo());
  },
  updateUser: (...params) => {
    dispatch(Actions.storeUserProfile.updateUser(...params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
